import { render } from "./TermAndConditionPage.vue?vue&type=template&id=73662359&scoped=true&ts=true"
import script from "./TermAndConditionPage.vue?vue&type=script&lang=ts"
export * from "./TermAndConditionPage.vue?vue&type=script&lang=ts"

import "./TermAndConditionPage.vue?vue&type=style&index=0&id=73662359&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73662359"]])

export default __exports__